export default {
    'form-toast-errors-title': 'O formulário teve os seguintes erros:',
    'form-toast-error-title': 'O formulário teve o seguinte erro:',
    'form-toast-error-message': 'deve ser preenchido',
    'TourImage': 'Imagens do Tour',
    'TourImage-actived': 'Ativo',
    'TourImage-name': 'Nome',
    'TourImage-sorter': 'Ordenação',
    'TourImage-updated-at': 'Atualizado em',
    'TourImage-created-at': 'Criado em',
    'seeMore': 'Ver mais',

  };
